<template>
  <div id="footer" class="footer">
    <div class="footer-box">
      <div class="row footer-content-box">
        <!-- <div class="col-xs-12 col-sm-7 col-md-7 footer-flex">
          <div class="" v-for="(item,index) in footerList" :key="index">
            <div class="footer-title">{{ item.title }}</div>
            <div class="footer-text" v-for="(val,ind) in item.children" :key="val.id">{{ val.title }}</div>
          </div>
        </div> -->
        <div class="col-12 col-xs-12 col-sm-6 col-md-6 footer-right-flex">
          <div>
            <div>
              <img class="logo-img" src="@/assets/image/logo.png" alt="">
            </div>
            <div class="footer-title">诺鲸智能科技（徐州）有限公司官网</div>
            <!-- <div class="footer-text">
              <span>江苏省徐州市泉山区淮海西路苏豪时代广场736</span>
            </div>
            <div class="footer-text">
              <span>13291015706</span>
            </div> -->
          </div>
        </div>
        <div class="col-12 col-xs-12 col-sm-6 col-md-6 footer-right-flex">
          <div class="footer-span">
            <div>
              <span>联系地址：</span>
              <span>江苏省徐州市泉山区淮海西路苏豪时代广场736</span>
            </div>
            <div>
              <span>商务合作：</span>
              <span>13291015706、4009661220</span>
            </div>
            <div>
              <span>微      信：</span>
              <span>jingqi5706</span>
            </div>
            <div>
              <span>邮      箱：</span>
              <span>danuojing@nuojing.net</span>
            </div>
          </div>
          
        </div>
        
        <!-- <div class="col-12 col-xs-12 col-sm-3 col-md-3 footer-right-flex">
          <div class="footer-img">
            <img class="info-img" src="@/assets/image/info.jpg" alt="">
          </div>
        </div> -->
      </div>
    </div>
    <div class="footer-ba">
      Copyright © 2020-2024 诺鲸智能科技（徐州）有限公司 苏ICP备18057599号
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
export default {
  name: "Footer",
  data() {
    return {
      footerList:[
        {
          id:1,
          title:"AI产品",
          children:[
            {
              id:101,
              title:"电话机器人"
            },
            {
              id:102,
              title:"文本机器人"
            },
          ]
        },
        {
          id:2,
          title:"通讯产品",
          children:[
            {
              id:201,
              title:"双呼小程序"
            },
            {
              id:202,
              title:"语音验证码"
            },
            {
              id:203,
              title:"语音通知"
            },
            {
              id:204,
              title:"SCRM"
            },
          ]
        },
        {
          id:3,
          title:"短信产品",
          children:[
            {
              id:301,
              title:"文本短信"
            },
            {
              id:302,
              title:"富媒体短信"
            },
            {
              id:303,
              title:"闪信"
            },
            {
              id:304,
              title:"5G消息"
            },
          ]
        },
        {
          id:4,
          title:"资源",
          children:[
            {
              id:401,
              title:"线路资源"
            },
            {
              id:402,
              title:"短信资源"
            },
          ]
        },
        {
          id:5,
          title:"解决方案",
          children:[
            {
              id:501,
              title:"金融"
            },
            {
              id:502,
              title:"房地产"
            },
            {
              id:503,
              title:"教育"
            },
            {
              id:504,
              title:"汽车"
            },
            {
              id:505,
              title:"政府"
            },
            {
              id:506,
              title:"商务服务"
            }
          ],
          
        },
      ],
      customerList: [
        {
          logo: require("@/assets/img/dyhlogo.png"),
        },
        {
          logo: require("@/assets/img/dehlogo.png"),
        },
        {
          logo: require("@/assets/img/dshlogo.png"),
        },
        
      ],
    };
  },
  mounted() {
    
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #000A18;
  overflow: hidden;
}
.footer-span{
  font-size: 14px;
}
@media screen and (min-width: 997px){
  .footer-box{
    padding: 50px 240px;
  }
  .footer-right-flex{
    justify-content: center;
  }
}
@media screen and (min-width: 768px) and (max-width: 996px){
  .footer-box{
    padding: 50px 50px;
  }
  .footer-right-flex{
    justify-content: flex-start;
  }
}
@media screen and (max-width: 768px){
  .footer-box{
    padding: 50px 20px;
  }
  .footer-right-flex{
    justify-content: flex-start;
  }
}
.footer-title{
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
}
.footer-text{
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999DA2;
}
.footer-flex{
  display: flex;
  justify-content: space-between;
  text-align: left;
  line-height: 26px;
}
.footer-right-flex{
  display: flex;
  text-align: left;
  line-height: 26px;
  position: relative;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
.logo-img{
  width: 45px;
  height: 28px;
  margin-bottom: 10px;
}
.footer-img{
  width: 131px;
  height: 189px;
  margin: 10px 0;
  /* position: absolute;
  bottom: -15px;
  right: 10px; */
}
.info-img{
  width: 100%;
  height: 100%;
}
.footer{
  position: relative;
}
.footer-ba{
  position: absolute;
  width: 90%;
  text-align: center;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
  color: #fff;
  font-size: 12px;
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue